document.addEventListener('DOMContentLoaded', function () {
    // Edit Channel modal on Partcipant

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.edit_ajax').each(function () {
        var $this = $(this);
        var editForm = $this.find('form[name=edit-channel]');
        var deleteForm = $this.find('form[name=delete-confirmation]');
        var formContainer = $this.find('.edit-form-container').hide();
        var deleteConfirm = $this.find('.delete-confirm-container').hide();
        var buttonContainer = $this.find('.button-container');

        var display = $this.find('.display');
        var cancel_btn = $this.find('.cancel');
        var edit_btn = $this.find('.edit-btn');
        var deleteBtn = $this.find('.delete-btn');
        edit_btn.click(function (e) {
            e.preventDefault();
            formContainer.show();
            display.hide();
            deleteConfirm.hide();
            buttonContainer.hide();

            cancel_btn.click(function () {
                e.preventDefault();
                buttonContainer.show();
                formContainer.hide();
                display.show();
            });
        });

        deleteBtn.on('click', function (e) {
            e.preventDefault();
            formContainer.hide();
            display.hide();
            deleteConfirm.show();
            buttonContainer.hide();

            $this.find('.delete-cancel').click(function () {
                e.preventDefault();
                buttonContainer.show();
                deleteConfirm.hide();
                display.show();
            });
        });

        var channelTypeInput = editForm.find('select[name="channel_type_id"]');
        channelTypeInput.change(function () {
            var addressFields = editForm.find('.address-field-container'),
                addressInput = editForm.find('[name=address]');

            if (channelTypeInput.val() == 4 || channelTypeInput.val() == 5) {
                addressFields.show();
                addressInput.hide();
            } else {
                addressFields.hide();
                addressInput.show();
            }
        });
        channelTypeInput.trigger('change');

        deleteForm.submit(function (evt) {
            evt.preventDefault();

            $.post(deleteForm.attr('action'), deleteForm.serialize(), function (obj) {
                // normal usage
                var href = window.location.href.split('#')[0];
                href = href + '#editchannels';
                window.location = href;
                window.location.reload(true);
            });
        });

        editForm.submit(function (e) {
            e.preventDefault();

            var url = editForm.attr('action');

            if (editForm.find('[name=channel_type_id]').val() == 4 || editForm.find('[name=channel_type_id]').val() == 5) {
                var addressObj = {};

                var street1 = editForm.find('input[name=street1]').val();
                if (street1) {
                    addressObj.street1 = street1;
                }
                var street2 = editForm.find('input[name=street2]').val();
                if (street2) {
                    addressObj.street2 = street2;
                }
                var city = editForm.find('input[name=city]').val();
                if (city) {
                    addressObj.city = city;
                }
                var state = editForm.find('select[name=state]').val();
                if (state) {
                    addressObj.state = state;
                }
                var zip = editForm.find('input[name=zip]').val();
                if (zip) {
                    addressObj.zip = zip;
                }

                editForm.find('input[name=address]').val(JSON.stringify(addressObj));
            }


            var data = editForm.serialize();
            $.post(url, data, function (obj) {
                // normal usage
                var href = window.location.href.split('#')[0];
                href = href + '#editchannels';
                window.location = href;
                window.location.reload(true);
            });
        });
    });

    $("a#addChannel").click(function (e) {
        e.preventDefault();
        $('#addChannelUI').show();
        $('#addChannelUI .panel-heading').trigger('click');
        $('#addChannelUI .edit-btn').trigger('click');
        $('#addChannelUI .delete-btn').hide();
        $(this).hide();
    });

    if (window.location.hash == '#editchannels') {
        $('#editall').modal().show();
    }

    doSurveyAddress();

    function doSurveyAddress() {
        var edit_ajax_survey = $('.edit_ajax_survey');
        // due to the way the survey works, use a div instead of a form element
        var form = edit_ajax_survey.find('#edit_ajax_form');
        ///
        form.find('.address_edit').show();
        form.find('.text_edit').hide();
        form.find('.btn-primary').click(function (e) {
            e.preventDefault();
            var string_address = [];
            var address_1 = form.find('input[name=address_1]').val();
            if (address_1) {
                string_address.push(address_1);
            }
            var address_2 = form.find('input[name=address_2]').val();
            if (address_2) {
                string_address.push(address_2);
            }
            var city = form.find('input[name=city]').val();
            if (city) {
                string_address.push(city);
            }
            var state = form.find('select[name=state]').val();
            if (state) {
                string_address.push(state);
            }
            var zip = form.find('input[name=zip]').val();
            if (zip) {
                string_address.push(zip);
            }
            string_address = string_address.join(';');
            form.find('input[name=channel_address]').val(string_address);
            var url = form.data('action');
            var data = form.find('input,select,textarea').serialize();
            $.post(url, data, function (obj) {
                var pid = $('#editall').data('pid');
                var href = '/participants/gethomeaddress/' + pid;
                $.post(href, {}, function (ret) {
                    $("#address_well").html(ret);
                    $('#editall').modal('toggle');
                    $('.modal-backdrop').remove();
                });
            });
        });
    }
})
